import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import Cookies from "js-cookie";

import { getOneTodoQueryOptions } from "@/config/queries/query-options";

const AdminIndividualTodoPage = () => {
  const adminKey = Cookies.get("key") as string;

  const { todoId } = useParams() as {
    todoId: string;
  };

  const { data } = useQuery(getOneTodoQueryOptions(adminKey, todoId));

  console.log("TOdo", data);

  return <div>Admin TODO Page</div>;
};

export default AdminIndividualTodoPage;
